export const getQueryParams = (locationSearch: string, keys: string[]): Array<string | null> => {
  const queryParam = new URLSearchParams(locationSearch);

  return keys.reduce((prev: Array<string | null>, curr) => {
    const param = queryParam.get(curr);
    prev.push(param);
    return prev;
  }, []);
};
